import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandler,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { FreightQuoteRequest, FreightQuoteResponse, getFreightQuote } from "@tCentro/Services/CENPDPFreightQuoteService";



type HandlerType = ApiHandler<
    FreightQuoteRequest & HasOnSuccess<FreightQuoteResponse>,
    FreightQuoteResponse &  HasOnError
>;


export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter; 
};


export const DispatchBeginFreightQuote: HandlerType = props => {
    (props as any).dispatch({
        type: "Custom/FreightQuote/BeginLoad",
    });
};


export const SendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = await getFreightQuote(props.apiParameter);
    } catch (error) {
        if (isApiError(error)) {
            const errorMsg = error.errorJson?.message || error.errorMessage;

            if (errorMsg) {
                logger.error("Freight Quote API error:", errorMsg);
                props.apiResult = { ...props.apiResult, errorMessage: errorMsg };
                return;
            }
        }

  
        logger.error("Unhandled Freight Quote API error:", error);
        
    }
};
export const ExecuteOnErrorCallback: HandlerType = props => {
    if ( props.apiResult?.errorMessage) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.apiResult?.errorMessage) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);
    }
};




export const DispatchCompleteFreightQuote: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    (props as any).dispatch({
        type: "Custom/FreightQuote/CompletedLoad",
        result: props.apiResult,
    });
};


export const chain = [
    DispatchBeginFreightQuote,
    PopulateApiParameter,
    SendDataToApi,
     ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
    DispatchCompleteFreightQuote,
];


const freightQuoteHandler = createHandlerChainRunner(chain, "freightQuoteHandler");

export default freightQuoteHandler;
